import { isToday, isYesterday } from "date-fns";
import moment from "moment";
import "moment-timezone";

const getFormattedDate = (currDate, format = "LLL") => {
  let isTodayOrYesterday = isToday(new Date(currDate)) || isYesterday(new Date(currDate));
  if (isTodayOrYesterday) return moment(currDate).calendar();
  else return moment(currDate).format(format);
};

export default getFormattedDate;
